import { useParams } from 'react-router-dom';
import { useProject } from '../hooks/useProject';
import { WizardLayout } from '../components/WizardLayout';
import { Spinner } from '../components/ui/Spinner';

export function ProjectPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const projectHook = useProject(projectId);

  // Keep the wizard mounted during background refetches so local stage UI state
  // (like pending AI suggestions) is not reset.
  if (projectHook.loading && !projectHook.project) {
    return (
      <div className="project-page__loading">
        <Spinner size="lg" />
        <p>Loading project...</p>
      </div>
    );
  }

  if (projectHook.error || !projectHook.project) {
    return (
      <div className="project-page__error">
        <h2>Failed to load project</h2>
        <p>{projectHook.error || 'Project not found'}</p>
      </div>
    );
  }

  return <WizardLayout projectHook={projectHook} />;
}
